import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Stack } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";

import useStackListAnalytics from "../../useStackListAnalytics";

const StacksTableDescriptionCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const trackAnalytics = useStackListAnalytics();

  const handleShowFullDescription = () => {
    trackAnalytics("Show full description clicked");
  };

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription
        description={stack.description}
        onShowFullDescription={handleShowFullDescription}
      />
    </TableSimpleCell>
  );
};

export default StacksTableDescriptionCell;
